<nx-pageTitle-box class="mb-3"
  [label]="'coreModule.mobileDeviceListComponent.title.label'"
  [icon]="'icon-mobile-device'"
  [iconToolTip]="'coreModule.mobileDeviceListComponent.title.tootltip'"
  [bcRootLvlLabel]="'coreModule.mobileDeviceListComponent.title.rootLevelLabel'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<div class="createdApiKey mt-3 w-5/5 mx-auto">
  <div class="flex flex-row bg-[#DAFF00] h-12 rounded-t-md">
    <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
      {{'coreModule.mobileDeviceListComponent.hint.header' | translate}}
    </div>
  </div>
  <div class="details-content">
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label font-medium">{{'coreModule.mobileDeviceListComponent.hint.text' | translate}}</div>
    </div>
  </div>
</div>

<div class="details mt-3">
  <nx-headline-box  
    [label]="'coreModule.mobileDeviceListComponent.appVersions.headline'">
      <ng-template nxTemplate="end">
        <nx-default-button
          *ngIf="rolesService.hasRole('framework_tenants_manage')"
          [style]="'light'"
          (click)="updateAppVersions()"
          [tooltip]="'coreModule.mobileDeviceListComponent.appVersions.editAppVersionsButton.label'"
          [icon]="'icon-edit'">
        </nx-default-button>
      </ng-template>
  </nx-headline-box>
  <div class="details-content">
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">{{'coreModule.mobileDeviceListComponent.appVersions.android' | translate}}</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span 
          *ngIf="isAdmin()"
          class="text-[#848488] text-sm font-light leading-3 pr-2">
          ({{'coreModule.mobileDeviceListComponent.appVersions.min' | translate}} {{ androidAppVersions?.minAppVersion }})
        </span>
        <span>{{ androidAppVersions?.latestAppVersion}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'coreModule.mobileDeviceListComponent.appVersions.goToGooglePlayStoreButtonTooltip'"
          (click)="openGooglePlayStore()"
          [icon]="'icon-link'">
        </nx-default-button>
      </div>
    </div>
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">{{'coreModule.mobileDeviceListComponent.appVersions.ios' | translate}}</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span 
          *ngIf="isAdmin()"
          class="text-[#848488] text-sm font-light leading-3 pr-2">
          ({{'coreModule.mobileDeviceListComponent.appVersions.min' | translate}} {{ iosAppVersions?.minAppVersion }})
        </span>
        <span>{{ iosAppVersions?.latestAppVersion}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'coreModule.mobileDeviceListComponent.appVersions.goToAppleAppStoreButtonTooltip'"
          (click)="openAppleAppStore()"
          [icon]="'icon-link'">
        </nx-default-button>
      </div>
    </div>
  </div>
</div>

<nx-headline-box  
  class="mt-3"
  [label]="'coreModule.mobileDeviceListComponent.deviceList.headline'"> 
    <ng-template nxTemplate="end">
      <input
        pInputText
        type="text"
        (input)="$any(mobileDeviceTable).filterGlobal($event.target?.['value'], 'contains')"
        class="p-inputtext p-component p-element"
        [placeholder]="'coreModule.mobileDeviceListComponent.deviceList.searchPalceholder' | translate" />
    </ng-template>
</nx-headline-box>
<p-table
  #mobileDeviceTable
  [lazy]="true"
  (onLazyLoad)="loadData($any($event))"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'{first} - {last} ' + ('core.common.paginator.currentPageReportSpacer' | translate) +' {totalRecords}'"
  [resizableColumns]="false">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <!-- no filter -->
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          [placeholder]="getPlaceholder()"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions | translateLabels"
          optionLabel="label"
          [dataKey]="'key'"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.name' | translate }}</th>
      <!-- <th>Offene Uploads</th> -->
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.user' | translate }}</th>
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.appVersion' | translate }}</th>
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.platform' | translate }}</th>
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.lastSeen' | translate }}</th>
      <th>{{ 'coreModule.mobileDeviceListComponent.deviceList.header.updateState' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-mobileDevice>
    <tr class="clickable" (click)="openMobileDevice(mobileDevice)">
      <td>{{mobileDevice?.name}}</td>
      <!-- <td>{{mobileDevice?.uploads?.length}}</td> -->
      <td>{{mobileDevice?.user?.firstName}} {{mobileDevice?.user?.lastName}}</td>
      <td>{{mobileDevice?.appVersion}}</td>
      <td>{{mobileDevice?.platform}}</td>
      <td>{{mobileDevice?.lastSeenDateTime | date:'dd.MM.yy HH:mm'}}</td>
      <td>
        <p-tag 
          [value]="updateLabel(mobileDevice?.updateState) | translate"
          [severity]="calculateSeverity(mobileDevice?.updateState)">
        </p-tag>
      </td>    
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="emptyMessage">{{ 'coreModule.mobileDeviceListComponent.deviceList.emptyMessage' | translate }}</td>
    </tr>
  </ng-template>
</p-table>

